import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { CircularProgress, createTheme, Grid, Stack } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { FormProvider, useForm } from "react-hook-form";
import rtlPlugin from "stylis-plugin-rtl";
import { Form, Forms } from "../../interfaces/forms";
import strings from "../../utils/strings.json";
import GButtonContained from "../GButtonContained";
import ComponentForm from "./ComponentForm";
import { prefixer } from "stylis";

interface FormProps {
  form: Forms;
  schema: any;
  defaultValues?: {};
  handleAction: (data) => void;
  handleClose?: () => void;
  isCoupon: boolean;
  children?: string | JSX.Element | JSX.Element[];
  loadingCoupon?: boolean;
}

function CreateForm(props: FormProps) {
  const onSubmit = (data) => {
    props.handleAction(data);
  };

  const methods = useForm({
    resolver: yupResolver(props.schema),
    defaultValues: props.defaultValues,
  });
  const theme = createTheme({
    direction: "rtl",
  });
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <CacheProvider value={cacheRtl}>
          <ThemeProvider theme={theme}>
            <Grid container rowSpacing={8} columnSpacing={5}>
              {props.form.data.map((data: Form, index: number) => (
                <Grid item xs={12} md={6}>
                  <ComponentForm key={index} field={data} />
                </Grid>
              ))}
              <Grid
                container
                item
                xs={props.isCoupon ? 12 : 12}
                sx={{
                  justifyContent: "end",
                }}
                pb={1}
              >
                <Stack
                  justifyContent="end"
                  pt={2}
                  sx={{
                    flexDirection: { xs: "column-reverse", sm: "row-reverse" },
                    alignItems: "center",
                  }}
                >
                  {props.loadingCoupon ? (
                    <CircularProgress sx={{ mr: 13 }} color="info" />
                  ) : (
                    <GButtonContained
                      text={
                        props.isCoupon
                          ? strings.button.check
                          : strings.button.next
                      }
                      type
                    />
                  )}

                  {props.children}
                </Stack>
              </Grid>
            </Grid>
          </ThemeProvider>
        </CacheProvider>
      </form>
    </FormProvider>
  );
}

export default CreateForm;
